<template>
	<div class="app-container">
		<el-row :gutter="20">
			<el-col :span="6" :xs="24">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>{{$t('userinfo.useravatar.title')}}</span>
					</div>
					<div>
						<div class="text-center">
							<userAvatar :user="user" />
						</div>

					</div>
				</el-card>
			</el-col>
			<el-col :span="18" :xs="24">
				<el-card>
					<div slot="header" class="clearfix">
						<span>{{$t('userinfo.title')}}</span>
					</div>
					<el-tabs v-model="activeTab">
						<el-tab-pane :label="this.$t('userinfo.tab1')" name="userinfo">
							<userInfo :user="user" />
						</el-tab-pane>
						<el-tab-pane :label="this.$t('userinfo.tab2')" name="resetPwd">
							<resetPwd :user="user" />
						</el-tab-pane>
					</el-tabs>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import userAvatar from "../../components/pages/userInfoManage/userAvatar";
	import userInfo from "../../components/pages/userInfoManage/userInfo";
	import resetPwd from "../../components/pages/userInfoManage/resetPwd";

	export default {
		name: "Profile",
		components: {
			userAvatar,
			userInfo,
			resetPwd
		},
		data() {
			return {
				user: {},
				roleGroup: {},
				postGroup: {},
				activeTab: "userinfo"
			};
		},
		created() {
			this.getUser();
		},
		methods: {
			getUser() {
				this.user = JSON.parse(window.localStorage.getItem("user"));
			}
		}
	};
</script>